import React from 'react'
import UserAvatar from './UserAvatar/UserAvatar'
import Tag from './Tag/Tag'
import { Tooltip } from 'antd'
import { es_dateFormat } from 'constants/date'
import moment from 'moment'

const getContent = (type = 'string', render = undefined as any, dateFormat = es_dateFormat, sensitive = false) => {
  switch (type) {
    case 'avatar':
      return (content: any, data: any) => getTooltip(data.tooltip, <UserAvatar user={(render && render(content, data)) || content} />, sensitive)
    case 'tag':
      return (content: any, data: any) => getTooltip(data.tooltip, <Tag data={(render && render(content, data)) || content} />, sensitive)
    case 'date':
      return (content: any, data: any) => getTooltip(data.tooltip, (render && render(content, data)) || content ? moment(moment(content).toDate()).format(dateFormat).toString() : '', sensitive)
    default:
      return (content: any, data: any) => getTooltip(data.tooltip, (render && render(content, data)) || content, sensitive)
  }
}

const getTooltip = (text: string, children: any, sensitive = false) => {
  if (!text) return <div className={sensitive ? 'sensitive' : ''}>{children}</div>
  return (
    <Tooltip placement="topLeft" title={text}>
      <div className={sensitive ? 'sensitive' : ''}> {children}</div>
    </Tooltip>
  )
}

export default getContent
